import React, { useState, useEffect } from 'react';
import { Button, Modal, Form, Message } from 'semantic-ui-react';
import { userService } from '../../../../store/services/ServiceUsers'
import { sharedAccessService } from "../../../../store/services/ServiceSharedAccess";
import { toast } from '../../../../components/others/ToastContainer';

const SharedAccessRequest = ({ setActiveFilter, onRequestComplete }) => {
    const [open, setOpen] = useState(false);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [formData, setFormData] = useState({
        provider: '',
        message: ''
    });

    const [providers, setProviders] = useState([]);

    const handleSubmit = async () => {
        setLoading(true);
        setError(null);
        const response = await sharedAccessService.createSharedAccessRequest(formData);
        if (response.status === 201) {
            setActiveFilter('pending');
            setOpen(false);
            setFormData({
                provider: '',
                message: ''
            });
            if (onRequestComplete) onRequestComplete("pending");
            toast({
                type: 'success',
                message: 'Žiadosť bola úspešne odoslaná'
            });
        }

        if (response.status === 400) {
            setError(response.response);
            toast({
                type: 'error',
                message: 'Nepodarilo sa odoslať žiadosť'
            });
        }

        setLoading(false);
    };

    useEffect(() => {
        const fetchProviders = async () => {
            const response = await userService.getProviders();
            setProviders(response.response);
        };
        fetchProviders();
    }, []);

    return (
        <>
            <Button color="pink" icon onClick={() => setOpen(true)}>
                <span>Vyžiadať vzdialený prístup </span>
            </Button>

            <Modal
                open={open}
                onClose={() => setOpen(false)}
                size="tiny"
            >
                <Modal.Header>Vyžiadať vzdialený prístup</Modal.Header>
                <Modal.Content>
                    {error?.detail && <Message negative>{error.detail}</Message>}
                    <Form>
                        <Form.Select
                            required
                            search
                            clearable
                            label="Vyberte zadávatela"
                            placeholder="Vyberte zadávatela"
                            error={error && error.provider?.[0]}
                            value={formData.provider}
                            onChange={(e, { value }) => setFormData({ ...formData, provider: value })}
                            options={providers.map(provider => ({
                                key: provider.id,
                                text: provider.name + ' (' + provider.email + ')',
                                value: provider.id
                            }))}
                        />
                        <Form.TextArea
                            label="Správa"
                            placeholder="Vyplňte správu pre zadávateľa..."
                            value={formData.message}
                            onChange={(e, { value }) => setFormData({ ...formData, message: value })}
                        />
                    </Form>
                </Modal.Content>
                <Modal.Actions>
                    <Button onClick={() => setOpen(false)}>Zrušiť</Button>
                    <Button color="pink" loading={loading} disabled={loading} onClick={handleSubmit}>
                        Odoslať žiadosť
                    </Button>
                </Modal.Actions>
            </Modal>
        </>
    );
};

export default SharedAccessRequest;
